import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import useAdminDashboard from "./useAdminDashboard";

const OrdersComponent = () => {
  const { orders, isLoading, errors } = useAdminDashboard(); // Assuming useAdminDashboard provides orders
  if (isLoading.orders) {
    return <CustomLoading />;
  }
  if (errors.orders) {
    return (
      <p className="text-xl font-semibold text-red-700">Some error occured!</p>
    );
  }
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EGP",
    }).format(amount);
  };

  const statusBreakdown = orders?.statusBreakdown || {};
  const statusStats = [
    {
      label: "Cancelled",
      value: statusBreakdown.Cancelled || 0,
      color: "text-red-600",
    },
    {
      label: "Processing",
      value: statusBreakdown.Processing || 0,
      color: "text-yellow-600",
    },
    {
      label: "Not processed",
      value: statusBreakdown["Not processed"] || 0,
      color: "text-gray-600",
    },
    {
      label: "Delivered",
      value: statusBreakdown.Delivered || 0,
      color: "text-green-600",
    },
    {
      label: "Shipped",
      value: statusBreakdown.Shipped || 0,
      color: "text-blue-600",
    },
  ];

  const recentOrders = (orders?.orders || []).slice(0, 3); // Show only top 3 orders

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100  ">
      <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
        >
          <path
            fill="#000"
            d="M11.25 18.75c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5m5-1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5m4.48-9.57l-2 8a.75.75 0 0 1-.73.57H8c-.36 0-.67-.26-.74-.62L5.37 5.25H4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.36 0 .67.26.74.62l.43 2.38H20a.754.754 0 0 1 .73.93m-1.69.57H7.44l1.18 6.5h8.79z"
            strokeWidth={0.5}
            stroke="#000"
          ></path>
        </svg>
        Order Analytics
      </h2>

      {/* Average Order Value */}
      <div className="text-center p-3 bg-gray-50 rounded-md mb-4">
        <p className="text-lg font-semibold text-green-600">
          {formatCurrency(orders?.averageOrderValue || 0)}
        </p>
        <p className="text-xs text-gray-600">Avg. Order Value</p>
      </div>

      {/* Status Breakdown */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
        {statusStats.map((stat, index) => (
          <div key={index} className="text-center p-3 bg-gray-50 rounded-md">
            <p className={`text-lg font-semibold ${stat.color}`}>
              {stat.value}
            </p>
            <p className="text-xs text-gray-600">{stat.label}</p>
          </div>
        ))}
      </div>

      {/* Recent Orders */}
      <div>
        <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-center">
          {/* <Star className="w-5 h-5 mr-2 text-yellow-500" /> */}
          Recent Orders
        </h3>
        <div className="space-y-2">
          {recentOrders.length > 0 ? (
            recentOrders.map((order) => (
              <div
                key={order._id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                    {order.user?.name?.charAt(0) || "U"}
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800 text-sm">
                      {order.user?.name || "Unknown User"}
                    </p>
                    <p className="text-xs text-gray-500 truncate max-w-[120px]">
                      {order._id.slice(-6)}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-green-600 text-sm">
                    {formatCurrency(order.amount)}
                  </p>
                  <p
                    className={`text-xs ${
                      statusStats.find((s) => s.label === order.status)
                        ?.color || "text-gray-500"
                    }`}
                  >
                    {order.status}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm">No order data available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrdersComponent;
